<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>Product Settings</glxy-page-title>
  </glxy-page-toolbar>

  <glxy-page-wrapper></glxy-page-wrapper>
</glxy-page>
